module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAVCAYAAABCIB6VAAABE0lEQVQ4jdXVzypEURwH8M9MtywkEcoWUWJhR7JQ8wqeQeY8gr03OCVPQdkpWaGUZqEssJadxUT+hMXcqds0cx3NbHzr1K/O+X0653cXt1Kv1yVkBA18YQXN9kaMsWtDNUXFLGYwl69fkwr/Ob3gZawl9NdCCBup8CiucI6lEnQBJzgLIUymwGMYyuuJEni6YAynwANJhlOtma7ioR8shDCPC1xXsan15PU+L0nrg4+jVhzFIMZSGSTWNf8T/szrZtnBxLSNtwxbWMTxAOAj7OImw2G++k6M8QN7dJ/xa6F+L3GeC/Vb52bWpeEJ25jCZQncwA5eYoyPKTAclIDF7Pf7BynmO+VQrxt35h63OXqX0vADuQcyJq0qlGYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-label-sees.png
// module id = 5o25
// module chunks = 1